import React from 'react';
import { upperCase } from 'lodash';
import Input from './Input';

export class CategoryOption extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			loading: false,
		};
	}

	getIcon() {
		let { selected } = this.props.optionData;
		let loading = this.props.optionData.loading || this.state.loading;

		if (loading) {
			return <i className="fas fa-asterisk fa-spin has-text-grey" />;
		}
		if (selected) {
			return <i className="fas fa-check-square has-text-link" />;
		}
		return <i className="far fa-square" />;
	}

	onSelectOption = () => {
		let { optionData, displayKey, dataKey } = this.props;

		this.setState({ loading: true });
		Promise.resolve(
			this.props.onOptionValueChange(!optionData.selected, optionData[dataKey])
		).then(() => this.setState({ loading: false }));
	};

	render() {
		let { optionData, displayKey, dataKey } = this.props;
		return (
			<div
				className={`level category-option mb-1 ${
					optionData.disabled ? 'disable' : ''
				}`}
				onClick={this.onSelectOption}
			>
				<div className="level-left overflow-hidden">
					<div className="level-item">
						<div className="icon">{this.getIcon()}</div>
					</div>
					<div className="level-item overflow-hidden">
						<p className="text-overflow-fade">{optionData[displayKey]}</p>
					</div>
				</div>
			</div>
		);
	}
}

class CategoryBox extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			expanded: ![null, undefined].includes(props.startExpanded)
				? props.startExpanded
				: true,
			loading: false,
		};
	}

	areAllSelected = () =>
		(this.props?.categoryData?.options || []).every((d) => d.selected);

	componentUpdate(prevProps) {
		if (this.props.startExpanded !== prevProps.startExpanded) {
			this.setState({
				expanded: this.props.startExpanded,
			});
		}
	}

	renderBulkSelectOption() {
		let allSelected = this.areAllSelected();
		let icon;
		let text;

		if (this.state.loading) {
			icon = <i className="fas fa-asterisk fa-spin has-text-grey" />;
			text = 'loading...';
		} else if (allSelected) {
			icon = <i className="fas fa-check-square has-text-link" />;
			text = 'Deselect All';
		} else {
			icon = <i className="far fa-square" />;
			text = 'Select All';
		}

		return (
			<div
				className="level category-option mb-4"
				onClick={() => this.bulkSelect()}
			>
				<div className="level-left overflow-hidden">
					<div className="level-item">
						<div className="icon">{icon}</div>
					</div>
					<div className="level-item overflow-hidden">
						<p className="text-overflow-fade">{text}</p>
					</div>
				</div>
			</div>
		);
	}

	bulkSelect = () => {
		this.setState({ loading: true });
		let allSelected = this.areAllSelected();
		Promise.resolve(
			this.props.onBulkOptionValueChange(
				!allSelected,
				this.props.categoryData.options
					.filter((d) => d.selected === allSelected)
					.map((d) => d[this.props.dataKey])
			)
		).then(() => {
			this.setState({ loading: false });
		});
	};

	render() {
		let { categoryData, categoryKey } = this.props;

		return (
			<div className="box category-box">
				<div
					className="level category-box-head overflow-hidden is-clickable"
					onClick={() => this.setState({ expanded: !this.state.expanded })}
				>
					<div className="level-left">
						<div className="level-item">
							<h5 className="is-size-5 has-text-weight-semibold has-text-primary">
								{categoryData.category}
							</h5>
						</div>
					</div>
					<div className="level-right">
						<div className="level-item">
							<span className="icon has-text-primary is-size-5">
								<i
									className={`fas fa-caret-${
										this.state.expanded ? 'down' : 'left'
									}`}
								/>
							</span>
						</div>
					</div>
				</div>

				{this.props.onBulkOptionValueChange && this.renderBulkSelectOption()}

				{this.state.expanded &&
					categoryData.options.map((d) => (
						<CategoryOption
							optionData={{ ...d, loading: d.loading || this.state.loading }}
							{...this.props}
							key={d[this.props.displayKey]}
						/>
					))}
			</div>
		);
	}
}

export default class SelectByCategory extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			searchVal: '',
			startExpanded: props.startExpanded,
		};
	}

	static defaultProps = {
		data: [],
		categoryKey: 'category', // value by which we split things, also the title of each category
		displayKey: 'name', // value displayed next to checkbox
		dataKey: 'id', // value passed to checkBox onChange function
		startExpanded: false,
	};

	getCategorizedData = () => {
		let { data, categoryKey, displayKey, dataKey } = this.props;
		let distinctCats = [...new Set(data.map((d) => d[categoryKey]))];
		let objForRender = [];
		distinctCats.forEach((category) => {
			let options = data.filter((d) => d[categoryKey] === category);

			if (this.state.searchVal && this.state.searchVal.length > 1) {
				options = options.filter((d) =>
					upperCase(d[displayKey]).includes(upperCase(this.state.searchVal))
				);
			}
			objForRender.push({ category, options });
		});

		return objForRender;
	};

	renderCategoryBoxes = () => {
		let renderData = this.getCategorizedData();
		let boxes = [];
		return renderData.map((d) => {
			// return <CategoryBox categoryData={d} {...this.props}/>
			return d.options.length ? (
				<CategoryBox
					categoryData={d}
					{...this.props}
					key={d[this.props.categoryKey]}
					startExpanded={this.state.startExpanded}
				/>
			) : (
				<></>
			);
		});
	};

	render() {
		return (
			<>
				<div className="level">
					<div className="level-left">
						{this.props.topLevelLeftHTML}
						<div className="level-item">
							<Input
								type="text"
								placeholder="search"
								onChange={(searchVal) => {
									this.setState({
										searchVal,
										startExpanded: !!searchVal.length,
									});
								}}
								value={this.state.searchVal}
							/>
						</div>
					</div>
					<div className="level-right">{this.props.topLevelRightHTML}</div>
				</div>
				<div
					className="select-by-cat-wrapper"
					style={this.props.wrapperStyle || {}}
				>
					{this.renderCategoryBoxes()}
				</div>
			</>
		);
	}
}
